import { useEffect, useState } from 'react'
import { client } from '../lib/sanity'
import { Post } from '../types/sanity'
import BlogPostCard from './BlogPostCard'

export default function BlogList() {
  const [posts, setPosts] = useState<Post[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const query = `*[_type == "post"] | order(publishedAt desc) {
      _id,
      title,
      description,
      readTime,
      slug,
      author->{
        _id,
        name,
        slug,
        image
      },
      mainImage,
      publishedAt,
      categories[]->{
        _id,
        title
      }
    }`

    client.fetch(query)
      .then((data: Post[]) => {
        setPosts(data)
        setLoading(false)
      })
      .catch((err) => {
        console.error('Error fetching posts:', err)
        setError(err.message)
        setLoading(false)
      })
  }, [])

  if (error) {
    return (
      <div className="text-center py-8 text-red-600">
        Error loading posts: {error}
      </div>
    )
  }

  if (loading) {
    return <div className="text-center py-8">Loading posts...</div>
  }

  if (posts.length === 0) {
    return <div className="text-center py-8">No posts found.</div>
  }

  const [featuredPost, ...remainingPosts] = posts;

  return (
    <div className="w-screen mb-16 md:mb-32">
      <div className="w-full px-4 md:px-8 md:max-w-[1280px] md:mx-auto">
        <div className="mb-8 md:mb-12">
          <h1 className="headline-large">Blog</h1>
        </div>
        
        {/* Featured Post */}
        <div className="mb-6 md:mb-8">
          <BlogPostCard post={featuredPost} featured={true} />
        </div>

        {/* Regular Posts Grid */}
        {remainingPosts.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 w-full">
            {remainingPosts.map((post) => (
              <BlogPostCard key={post._id} post={post} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
} 